import { render, staticRenderFns } from "./BaseDatePicker.vue?vue&type=template&id=063fb23e&scoped=true&"
import script from "./BaseDatePicker.vue?vue&type=script&lang=ts&"
export * from "./BaseDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDatePicker.vue?vue&type=style&index=0&id=063fb23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063fb23e",
  null
  
)

export default component.exports